/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateJobRoleData
 */
export interface UpdateJobRoleData {
    /**
     * 
     * @type {string}
     * @memberof UpdateJobRoleData
     */
    name?: string;
    /**
     * The status of the entity.
     * @type {string}
     * @memberof UpdateJobRoleData
     */
    status?: UpdateJobRoleDataStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobRoleData
     */
    colour?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateJobRoleData
     */
    position?: number;
}

/**
* @export
* @enum {string}
*/
export enum UpdateJobRoleDataStatusEnum {
    Active = 'Active',
    Archived = 'Archived',
    Deleted = 'Deleted'
}


/**
 * Check if a given object implements the UpdateJobRoleData interface.
 */
export function instanceOfUpdateJobRoleData(value: object): value is UpdateJobRoleData {
    return true;
}

export function UpdateJobRoleDataFromJSON(json: any): UpdateJobRoleData {
    return UpdateJobRoleDataFromJSONTyped(json, false);
}

export function UpdateJobRoleDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateJobRoleData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'status': json['status'] == null ? undefined : json['status'],
        'colour': json['colour'] == null ? undefined : json['colour'],
        'position': json['position'] == null ? undefined : json['position'],
    };
}

  export function UpdateJobRoleDataToJSON(json: any): UpdateJobRoleData {
      return UpdateJobRoleDataToJSONTyped(json, false);
  }

  export function UpdateJobRoleDataToJSONTyped(value?: UpdateJobRoleData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'status': value['status'],
        'colour': value['colour'],
        'position': value['position'],
    };
}

